import * as React from 'react';
import {
  TextField as MuiTextField,
  type TextFieldProps as MuiTextFieldProps,
  Icon,
  InputAdornment,
} from '@mui/material';

import type { BaseComponentProps } from '../utils/types';

export interface SearchFieldProps
  extends BaseComponentProps,
    Pick<
      MuiTextFieldProps,
      | 'inputRef'
      | 'size'
      | 'defaultValue'
      | 'color'
      | 'variant'
      | 'value'
      | 'type'
      | 'name'
      | 'autoComplete'
      | 'label'
      | 'placeholder'
      | 'helperText'
      | 'disabled'
      | 'onKeyDown'
      | 'onChange'
      | 'onFocus'
      | 'onBlur'
      | 'error'
      | 'autoFocus'
      | 'fullWidth'
    > {
  endAdornment?: React.ReactNode;
}

export const SearchField = ({
  variant = 'outlined',
  color = 'primary',
  autoFocus = true,
  fullWidth = true,
  size,
  endAdornment,
  ...otherProps
}: SearchFieldProps) => {
  return (
    <MuiTextField
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Icon style={{ alignSelf: 'center' }}>search</Icon>
          </InputAdornment>
        ),
        endAdornment,
      }}
      color={color}
      size={size}
      variant={variant}
      autoFocus={autoFocus}
      fullWidth={fullWidth}
      {...otherProps}
    />
  );
};
